<app-loading-view />
<app-nav-drawer />
<app-notifications />
<app-session-expired-dialog />
<app-new-version-dialog />
